"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _CalendarOptionButtons = require("./CalendarOptionButtons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isAndroidDevice() {
  return /(android)/i.test(navigator.userAgent);
}

function getOnlineLocationDescription(_ref) {
  var booking = _ref.booking,
      i18n = _ref.i18n;
  var description = booking.location_url || i18n.nullTeleconferenceUrl;

  if (booking.service.location_url_notes) {
    description += "\n".concat(booking.service.location_url_notes);
  }

  if (booking.service.description) {
    description += "\n\n".concat(booking.service.description);
  }

  return description;
}

var style = {
  display: 'flex',
  flexWrap: 'nowrap'
};

var CalendarOptionButtonsList = function CalendarOptionButtonsList(_ref2) {
  var booking = _ref2.booking,
      businessName = _ref2.businessName,
      domainName = _ref2.domainName,
      i18n = _ref2.i18n,
      onAddToCalendarClick = _ref2.onAddToCalendarClick,
      onAddToCalendarMount = _ref2.onAddToCalendarMount;
  var Block = _guacWidgetCore.UX2.Element.Block;
  var event = {
    title: booking.service.name,
    description: booking.service.description,
    start: booking.start_time,
    location: "".concat(businessName, ", ").concat(booking.location.formatted_address.address_lines.join(', ')),
    end: booking.end_time_display,
    url: domainName
  };

  if (booking.service.location_type === 'online') {
    event.url = booking.location_url;
    event.location = i18n.externalCalOnlineLocation;
    event.description = getOnlineLocationDescription({
      booking: booking,
      i18n: i18n
    });
  }

  var calendarButtonProps = {
    event: event,
    onAddToCalendarClick: onAddToCalendarClick,
    onAddToCalendarMount: onAddToCalendarMount
  };
  return /*#__PURE__*/_react["default"].createElement(Block, {
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_CalendarOptionButtons.GoogleCalendarButton, calendarButtonProps), isAndroidDevice() ? /*#__PURE__*/_react["default"].createElement(_CalendarOptionButtons.AndroidCalendarButton, calendarButtonProps) : /*#__PURE__*/_react["default"].createElement(_CalendarOptionButtons.IcalButton, calendarButtonProps), /*#__PURE__*/_react["default"].createElement(_CalendarOptionButtons.OutlookButton, calendarButtonProps));
};

CalendarOptionButtonsList.propTypes = {
  booking: _propTypes["default"].object.isRequired,
  domainName: _propTypes["default"].string.isRequired,
  businessName: _propTypes["default"].string.isRequired,
  i18n: _propTypes["default"].shape({
    externalCalOnlineLocation: _propTypes["default"].string,
    nullTeleconferenceUrl: _propTypes["default"].string.isRequired
  }).isRequired,
  onAddToCalendarClick: _propTypes["default"].func,
  onAddToCalendarMount: _propTypes["default"].func
};
var _default = CalendarOptionButtonsList;
exports["default"] = _default;